import { render, staticRenderFns } from "./gradeDialog.vue?vue&type=template&id=640dd024&"
import script from "./gradeDialog.vue?vue&type=script&lang=js&"
export * from "./gradeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports